(function() {
  'use strict';

  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.error('MTGwScroll2: GSAP or ScrollTrigger is not loaded');
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  // Keep native scrollbar and animation progress in sync on this page.
  const ENABLE_LENIS_PROXY = false;

  function setupLenisForScrollTrigger() {
    if (!ENABLE_LENIS_PROXY) return;
    // Avoid multiple scrollerProxy setups from other sections.
    if (window.__mtLenisScrollProxySetup) return;

    if (typeof Lenis === 'undefined') return;

    window.__mtLenisScrollProxySetup = true;

    if (!window.lenisInstance) {
      window.lenisInstance = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        smoothWheel: true,
        wheelMultiplier: 0.7,
        smoothTouch: false,
        touchMultiplier: 2,
        infinite: false
      });
    }

    const lenis = window.lenisInstance;

    lenis.on('scroll', () => ScrollTrigger.update());

    ScrollTrigger.scrollerProxy(document.body, {
      scrollTop(value) {
        if (arguments.length) {
          lenis.scrollTo(value, { immediate: true });
        } else {
          return lenis.scroll;
        }
      },
      getBoundingClientRect() {
        return {
          top: 0,
          left: 0,
          width: window.innerWidth,
          height: window.innerHeight
        };
      }
    });

    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);

    document.documentElement.classList.add('lenis');
  }

  function initSection(sectionId) {
    const section = document.getElementById(sectionId);
    if (!section) return;
    if (section.dataset.mtgws2Inited === '1') return;
    section.dataset.mtgws2Inited = '1';

    const pinEl = section.querySelector('.mt-gw-scroll2-pin') || section;
    const cards = section.querySelectorAll('.mt-gw-scroll2-card[data-mt-gw-scroll2-card]');
    if (!cards || cards.length === 0) return;

    const isMobile = window.innerWidth < 768;

    setupLenisForScrollTrigger();

    const totalCards = cards.length;
    const ROTATE_DEG = 15;

    const startYOffset = () => window.innerHeight * 0.65;  // 从右下开始更“贴底”
    const endYOffset = () => -window.innerHeight * 1.25;  // 往上飞出屏幕

    // 给初始出现一个右下角的横向偏移，让“飘上来”更有空间感
    // 轨道结束时收回到 x:0（同一条纵向轨道）
    const startXOffset = () => Math.max(60, window.innerWidth * 0.12);

    // 移动端：不 pin，卡片在文档流中滚动；滚入 -> 回正(0deg) 后停在当前位置
    if (isMobile) {
      const mobileStartYOffset = () => window.innerHeight * 0.35;

      cards.forEach((card) => {
        gsap.set(card, {
          opacity: 0,
          visibility: 'hidden',
          y: mobileStartYOffset(),
          x: 0,
          rotation: ROTATE_DEG
        });
      });

      cards.forEach((card) => {
        ScrollTrigger.create({
          trigger: card,
          start: 'top 90%',
          end: 'top 55%',
          scrub: true,
          onEnter: () => gsap.set(card, { visibility: 'visible' }),
          onLeaveBack: () => gsap.set(card, { visibility: 'hidden' }),
          onUpdate: (self) => {
            const p = Math.max(0, Math.min(1, self.progress));
            const y = mobileStartYOffset() * (1 - p);
            const rotation = ROTATE_DEG * (1 - p);
            gsap.set(card, {
              opacity: p,
              y,
              x: 0,
              rotation
            });
          }
        });
      });

      const onResize = () => ScrollTrigger.refresh();
      window.addEventListener('resize', onResize);
      ScrollTrigger.refresh();
      return;
    }

    // 初始：只显示左侧文字；右侧卡片全部隐藏
    cards.forEach((card) => {
      gsap.set(card, {
        opacity: 0,
        visibility: 'hidden',
        y: startYOffset(),
        x: startXOffset(),
        rotation: ROTATE_DEG,
      });
    });

    const scrollTriggerConfig = {
      trigger: pinEl,
      start: 'top top',
      end: () => `+=${Math.round(window.innerHeight * (1.4 + totalCards * 0.55))}px`,
      pin: true,
      anticipatePin: 1,
      // Using document.body scrollerProxy when Lenis is enabled
    };

    if (window.lenisInstance) {
      scrollTriggerConfig.scroller = document.body;
    }

    const tl = gsap.timeline({ paused: true });

    // 时间轴：让卡片依次出现、依次从下往上飘过中线回正，再继续上飞消失
    const perCardSpan = 0.62; // 每张卡占用的“轨道进度”
    const gapSpan = 0.08;    // 卡片之间的间隔

    cards.forEach((card, index) => {
      const start = ((perCardSpan + gapSpan) * index) / Math.max(1, totalCards);
      const end = start + perCardSpan;

      // 出现
      tl.set(card, { opacity: 1, visibility: 'visible' }, start);
      // 上飞（不直接动画 rotation，由 onUpdate 实时根据“到达中线”控制回正）
      tl.to(
        card,
        {
          y: endYOffset,
          x: 0,
          duration: end - start,
          ease: 'none',
          overwrite: 'auto',
        },
        start
      );
      // 消失
      tl.set(card, { opacity: 0, visibility: 'hidden' }, end);
    });

    const viewportCenterY = () => window.innerHeight / 2;
    const straightenZone = () => Math.max(220, window.innerHeight * 0.25);

    tl.eventCallback('onUpdate', () => {
      const vcy = viewportCenterY();
      const zone = straightenZone();

      cards.forEach((card) => {
        if (card.style.visibility === 'hidden') return;

        const rect = card.getBoundingClientRect();
        const cardCenterY = rect.top + rect.height / 2;
        const dist = cardCenterY - vcy; // >0 在中心下方（回正阶段），<=0 已过中心（保持 0）

        // 三段旋转：
        // 1) dist >= zone：保持出现时的倾斜（+15deg）
        // 2) dist 从 zone -> 0：逐步回正到 0deg
        // 3) dist 从 0 -> -zone：继续倾斜到与出现方向相反（-15deg）
        const initialRotation = ROTATE_DEG;
        const oppositeRotation = -ROTATE_DEG;

        let rotation;
        if (dist >= zone) {
          rotation = initialRotation;
        } else if (dist > 0) {
          const t = Math.max(0, Math.min(1, dist / zone)); // zone -> 1, 0 -> 0
          rotation = initialRotation * t;
        } else if (dist > -zone) {
          const t = Math.max(0, Math.min(1, (-dist) / zone)); // 0 -> 0, -zone -> 1
          rotation = oppositeRotation * t;
        } else {
          rotation = oppositeRotation;
        }

        gsap.set(card, { rotation });
      });
    });

    const lastCard = cards[totalCards - 1];
    let freezeAtScrollProgress = null;

    ScrollTrigger.create({
      ...scrollTriggerConfig,
      scrub: 1.2,
      onUpdate: (self) => {
        if (freezeAtScrollProgress !== null && self.progress < freezeAtScrollProgress - 0.001) {
          // 用户回滚到锁定点之前，恢复正常联动
          freezeAtScrollProgress = null;
        }

        const effectiveProgress = freezeAtScrollProgress === null
          ? self.progress
          : Math.min(self.progress, freezeAtScrollProgress);

        tl.progress(effectiveProgress);

        if (freezeAtScrollProgress === null) {
          const rect = lastCard.getBoundingClientRect();
          const lastCardCenterY = rect.top + rect.height / 2;
          if (lastCardCenterY <= viewportCenterY()) {
            // 最后一张真正到达中线后锁住后续动画
            freezeAtScrollProgress = self.progress;
            tl.progress(freezeAtScrollProgress);
          }
        }
      }
    });

    const onResize = () => ScrollTrigger.refresh();
    window.addEventListener('resize', onResize);
    tl.eventCallback('onKill', () => window.removeEventListener('resize', onResize));

    ScrollTrigger.refresh();
  }

  window.MTGwScroll2 = {
    init(options) {
      if (!options || !options.sectionId) return;
      initSection(options.sectionId);
    }
  };
})();

